<template>
  <div class="create-account">
    <div class="breadcrumb-area pos-relative" style="display: flex; justify-content: space-between">
      <h1>{{ idUpdate ? "Cập nhật tài khoản" : "Tạo tài khoản" }}</h1>
      <button class="btn btn-outline-secondary" @click="$router.push('/agent-bank')"
        style="display: flex; align-items: center">
        <i class="bx bx-arrow-back mr-1"></i> <span>Quay lại</span>
      </button>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <div class="ml-3 p-3 mt-2 " style="max-width: 900px; border: 1px solid #d7d7d7;border-radius: 10px;">
        <div class="card-body p-1">
          <form @submit.prevent="submitForm">
            <b-row>
              <b-col>
                <div class="form-group mb-3">
                  <label for="name">Tên tài khoản <span style="color: red">*</span></label>
                  <input type="text" id="name" class="form-control" v-model="formData.name"
                    placeholder="Nguyễn Văn A - BIDV123" required :disabled="idUpdate" />
                </div>
                  <div class="form-group mb-3">
                  <label for="name">Số điện thoại</label>
                  <input type="text" id="mobile" class="form-control" v-model="formData.mobile"
                    placeholder="SĐT" />
                </div>
                <div class="form-group mb-3">
                  <label for="email">Email <span style="color: red">*</span></label>
                  <input type="email" id="email" class="form-control" v-model="formData.email"
                    placeholder="nguyenvana@bidv.com" required  />
                </div>

                <div class="form-group mb-3">
                  <label for="cityCode">Tỉnh thành <span style="color: red">*</span></label>
                  <Select2 id="cityCode" v-model="formData.cityCode" :options="provinceOptions" placeholder="Hà Nội"
                    @change="getListDictrict" required :disabled="idUpdate" />
                </div>

                <div class="form-group mb-3">
                  <label for="districtCode">Quận huyện <span style="color: red">*</span></label>
                  <Select2 id="districtCode" v-model="formData.districtCode" :options="districtOptions"
                    placeholder="Quận huyện" required />
                </div>

                <div class="form-group mb-3">
                  <label for="address">Địa chỉ <span style="color: red">*</span></label>
                  <input type="text" id="address" class="form-control" v-model="formData.address"
                    placeholder="123 abc, abcd" required />
                </div>
              </b-col>
              <b-col>
                <div class="form-group" v-if="dataUser?.level === 0">
                  <label for="partnerCode">Đối tác <span style="color: red">*</span></label>
                  <Select2 v-model="formData.partnerCode" :disabled="idUpdate" @change="loadUser" id="partnerCode" :options="partnerOption" required
                    placeholder="Chọn đối tác" />
                </div>
                <div class="form-group mb-3">
                  <label for="level">Cấp độ <span style="color: red">*</span></label>
                  <Select2 id="level" v-model="formData.level" :disabled="idUpdate"  @change="loadUser" :options="levelUerAgentBank" placeholder="Chọn cấp độ"
                    required />
                </div>

                <div class="form-group mb-3" v-if="formData?.level > 1">
                  <label for="managerId">Quản lý <span style="color: red">*</span></label>
                  <Select2 required id="managerId" :disabled="managerOptions?.length === 0" v-model="formData.managerId" :options="managerOptions"
                    placeholder="Chọn quản lý" />
                </div>
                 <div class="form-group mb-3">
                  <label for="typeAccount">Loại tài khoản <span style="color: red">*</span></label>
                  <Select2 required id="typeAccount" v-model="formData.typeDigital"  :disabled="idUpdate" :options="[{id: 'NORMAL', text: 'Tài khoản tự bán thiết bị'}, {id: 'DIGITAL', text: 'Tài khoản giới thiệu merchant'}]"
                    placeholder="Chọn loại tài khoản" />
                </div>
              </b-col>
            </b-row>

            <div class="d-flex mt-4">
              <button type="button" class="btn btn-secondary flex-grow-1 mr-2" @click="$router.push('/agent-bank')">
                Hủy
              </button>
              <button type="submit" class="btn btn-primary flex-grow-1">
                {{ idUpdate ? "Lưu" : "Tạo tài khoản" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import { CommonService } from '@/services/common.service'

export default {
  name: 'AccountCreate',
  data () {
    return {
      idUpdate: this.$route.params.id,
      multiple: true,
      showLoading: false,
      dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
      partnerOption: [],
      // setTingsInviteCode: {
      //   ajax: {
      //     delay: 500,
      //     transport: (params, success, failure) => {
      //       const txtSearch = params.data?.q?.trim() || ''
      //       if (!txtSearch) {
      //         return success({
      //           results: []
      //         })
      //       }
      //       const keySearch = txtSearch ?? ''
      //       if (this.tLoadOwner) {
      //         clearTimeout(this.tLoadOwner)
      //       }
      //       this.tLoadOwner = setTimeout(() => {
      //         CommonService.getListPartnerCode({
      //           keyword: keySearch,
      //           limit: 20,
      //           page: 1
      //         }) // AI
      //           .then((res) => {
      //             success({
      //               results:
      //                 res.data?.map((item) => {
      //                   return {
      //                     id: item?.code || '',
      //                     text: item.name || ''
      //                   }
      //                 }) || []
      //             })
      //           })
      //           .catch(failure)
      //       }, 500)
      //     }
      //   }

      // },
      levelUerAgentBank: [],
      formData: {
        name: '',
        email: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        address: '',
        level: '1',
        managerId: '',
        managerName: ''
        // stateAgent: 'ACTIVE'
      },
      provinceOptions: [],
      districtOptions: [],
      managerOptions: []

    }
  },
  computed: {},
  async created () {
    if (this.idUpdate) {
      await this.getDataUpdate()
    }
    // Khởi tạo các options từ API
    await this.getAgentPartner()
    await this.getAgentLevel()
    await this.loadUser()
    this.loadCity()
  },
  methods: {

    async getAgentLevel () {
      // AI
      try {
        // AI
        const data = await CommonService.getAgentLevel({
          limit: 1000,
          page: 1
        })

        if (data.code === 1000) {
          // AI
          this.levelUerAgentBank =
            data.data.map((e) => {
              // AI
              return {
                // AI
                id: e.level,
                text: e.name // AI
              } // AI
            }) || [] // AI
          this.levelUerAgentBank = this.levelUerAgentBank.filter(e => Number(e.id) > Number(this.dataUser?.level))
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
      }
    },
    async getAgentPartner () {
      // AI
      try {
        // AI
        const data = await CommonService.getListPartnerCode()

        if (data.code === 1000) {
          // AI
          this.partnerOption =
            data.data.map((e) => {
              // AI
              return {
                // AI
                id: e.code,
                text: e.name // AI
              } // AI
            }) || [] // AI
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
      }
    },
    async getDataUpdate () {
      this.showLoading = true
      // AI
      try {
        // AI
        const data = await CommonService.detailteUserBank(this.idUpdate) // AI
        if (data.success) {
          // AI
          this.formData = data.data
          this.getListDictrict(data.data.cityCode)
        }
      } catch (error) {
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      } finally {
        this.showLoading = false // AI
      } // AI
    },
    async loadUser () {
      if (this.formData?.level === 1) return

      // AI
      try {
        // AI
        const data = await CommonService.getListUserBank({
          // AI
          level: this.formData.level - 1, // AI
          partnerCode: this.formData.partnerCode
        }) // AI
        if (data.success) {
          // AI
          this.managerOptions =
            data.data.map((e) => {
              // AI
              return {
                // AI
                id: e.agentId,
                text: e.name + ' - ' + e.email || '' // AI
              } // AI
            }) || [] // AI
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      }
    },
    async loadCity () {
      // AI
      try {
        const provinceRes = await CommonService.getProvince({}) // AI

        if (provinceRes.success) {
          // AI
          this.provinceOptions =
              provinceRes.data.map((s) => ({ id: s.code, text: s.name })) || [] // AI
        } // AI
        this.provinceOptions.unshift({ id: '0', text: 'Tất cả' })
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      }
    },
    async getListDictrict (code) {
      // AI
      this.loadingDictric = true // AI
      try {
        // AI
        const data = await CommonService.getDistrict({ cityCode: code }) // AI
        if (data.success) {
          // AI
          this.districtOptions =
            data.data.map((s) => ({ id: s.code, text: s.name })) || [] // AI
        } // AI
      } catch (error) {
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      } finally {
        this.loadingDictric = false // AI
      } // AI
    },

    submitForm () {
      // Cập nhật districtName
      if (this.formData.districtCode) {
        const selectedDistrict = this.districtOptions.find(
          (district) => district.id === this.formData.districtCode
        )
        if (selectedDistrict) {
          this.formData.districtName = selectedDistrict.text
        }
      }

      // Cập nhật managerName
      if (this.formData.cityCode) {
        const selectedCity = this.provinceOptions.find(
          (city) => city.id === this.formData.cityCode
        )
        if (selectedCity) {
          this.formData.cityName = selectedCity.text
        }
      }
      this.formData.level = Number(this.formData.level)
      if (this.idUpdate) {
        delete this.formData.name
        delete this.formData.cityCode
        delete this.formData.cityName
        // delete this.formData.email
        this.onSubmitUpdate(this.formData)
      } else {
        this.onSubmitAdd(this.formData)
      }
    },
    async onSubmitUpdate (params) {
      params.id = this.idUpdate

      try {
        this.showLoading = true
        const data = await CommonService.updateUserBank(params)
        if (data.success) {
          this.showSuccessMx(
            `Đã cập nhật thành công tài khoản có email: ${data.data.email}`
          ).then((s) => this.$router.push('/agent-bank'))
        } else this.showFailMx(data.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    },
    async onSubmitAdd (params) {
      try {
        this.showLoading = true
        const data = await CommonService.addUserBank(params)
        if (data.success) {
          this.showSuccessMx(
            `Tạo tài khoản thành công. Mật khẩu đã được gửi vào email: ${data.data.email}`
          ).then((s) => this.$router.push('/agent-bank'))
        } else this.showFailMx(data.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped>
.form-group label {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
